<div class="max-w-[80vw]">
    <form [formGroup]="form">
        
        <!-- Header -->
        <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary" style="margin: -24px;">
            <div class="text-lg font-medium">{{location ? 'Edit' : 'Add'}} Part Location</div>
            <button
                mat-icon-button
                (click)="close()"
                [tabIndex]="-1">
                <mat-icon
                    class="text-current"
                    [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>
        
        <div class="grid sm:grid-cols-4 gap-x-6 gap-y-4 w-full mt-12">

            <div class="col-span-4">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Location Type</mat-label>
                    <mat-select formControlName="locationType" placeholder="Select Type..." (selectionChange)="locationTypeChanged($event)">
                        <ng-container *ngFor="let option of locationTypes">
                            <mat-option [value]="option.value">{{option.name}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-span-4">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Parent Location</mat-label>
                    <mat-select formControlName="parentLocationId" [required]="requiresParentId()" [disabled]="!requiresParentId()" placeholder="Select Parent...">
                        <ng-container *ngFor="let option of parentLocations">
                            <mat-option [value]="option.partLocationId">{{option.code}}</mat-option>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>
            
            <div class="col-span-2 row-span-3">
                <div id="qr-print-area" class="qr-border border-solid border-black border-4 p-1 rounded-2xl bg-white">
                    <qrcode
                        [qrdata]="'nexus-part-location-' + getFullLocationPath()"
                        [width]="256"
                        [errorCorrectionLevel]="'M'"
                        [elementType]="'svg'"
                        allowEmptyString
                    ></qrcode>
                    <div class="text-center font-bold text-lg mt-1 pb-1">{{getFullLocationPath()}}</div>
                </div>
                <button mat-stroked-button class="w-full mt-2" (click)="printQrCode()" type="button">
                    <mat-icon svgIcon="heroicons_outline:printer" class="icon-size-4"></mat-icon>
                    <span class="ml-1">Print Label</span>
                </button>
            </div>
            
            <div class="col-span-2">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Code</mat-label>
                    <input formControlName="code" matInput placeholder="e.g. E, F, G">
                </mat-form-field>
            </div>
            <div class="col-span-2">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Name</mat-label>
                    <input formControlName="name" matInput placeholder="e.g. Packaging Materials">
                </mat-form-field>
            </div>
            <div class="col-span-2">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Capacity</mat-label>
                    <input formControlName="capacity" type="number" matInput placeholder="Max bins/items">
                </mat-form-field>
            </div>
            
            <div class="col-span-4">
                <mat-form-field class="w-full fuse-mat-dense" [subscriptSizing]="'dynamic'">
                    <mat-label>Notes</mat-label>
                    <textarea
                        formControlName="notes"
                        placeholder="Temperature controlled, ATEX zone, hazardous materials, etc."
                        matInput
                        [rows]="2"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="2">
                    </textarea>
                </mat-form-field>
            </div>

        </div>

        <!-- Divider -->
        <div class="mt-11 mb-10 border-t"></div>

        <!-- Actions -->
        <div class="flex flex-row items-between w-full gap-4">
            <div class="flex items-center justify-end ml-auto">
                <button
                    (click)="close()"
                    mat-stroked-button
                    type="button">
                    Cancel
                </button>

                <button
                    (click)="save()"
                    class="ml-4"
                    mat-flat-button
                    type="button"
                    [color]="'primary'"
                    [disabled]="!form?.valid || form?.pristine">
                    {{location ? 'Save' : 'Create'}}            
                </button>
            </div>
        </div>
    </form>

</div>
